import React from "react";
import SidePanelSection from "components/shared-ui/side-panel-section/side-panel-section";
import { Switch } from "components/shared-ui/input/switch/switch";

export interface IMfaStatusSectionProps {
  title?: string;
  enabled: boolean;
  onChange: (value: boolean) => void;
  testId?: string;
}

export default function MfaStatusSection(props: IMfaStatusSectionProps) {
  const testId = props.testId ?? "mfa-status-section";

  return (
    <SidePanelSection title={props.title ?? "Status"} testId={testId}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span>{props.enabled ? "MFA Enabled" : "MFA Disabled"}</span>
        <Switch testId={`${testId}-toggle`} checked={props.enabled} onChange={props.onChange} />
      </div>
    </SidePanelSection>
  );
}
